import { render, staticRenderFns } from "./Stock_List.vue?vue&type=template&id=ed2e9728&scoped=true&"
import script from "./Stock_List.vue?vue&type=script&lang=js&"
export * from "./Stock_List.vue?vue&type=script&lang=js&"
import style0 from "./Stock_List.vue?vue&type=style&index=0&id=ed2e9728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2e9728",
  null
  
)

export default component.exports